import { Tag, Text } from '@chakra-ui/react'
import { Hospital } from '@phosphor-icons/react'
import React from 'react'

interface Props {
	title: string,
}

const Indicator = ({ title }: Props) => {
	return (
		<Tag size="md" colorScheme="blue">
			<Hospital weight="fill" size="22" />
			<Text ml="2" fontSize="md">{title}</Text>
		</Tag>
	)
}

export default Indicator
